<script setup>
const props = defineProps({
  orderBy: {
    type: String,
    required: false,
    default: undefined,
  },
  orderDirection: {
    type: String,
    required: false,
    default: undefined,
    validator(value) {
      return ['asc', 'desc'].includes(value);
    }
  },
  name: {
    type: String,
    required: false,
    default: undefined,
  },
  colSpan: {
    type: [Number, String],
    required: false,
    default: 1,
  },
  centered: {
    type: Boolean,
    required: false,
    default: false,
  }
});

const emit = defineEmits(['orderChanged'])

const handleClick = () => {
  if (!props.name) return;

  emit('orderChanged', props.name);
}

</script>

<template>
  <div
    :class="[
      `tw-col-span-${colSpan}`,
      'tw-py-2 tw-flex tw-items-center tw-cursor-pointer tw-group tw-text-grey-dark tw-px-4 tw-text-sm tw-gap-1',
      {'tw-justify-center tw-text-center': centered},
    ]"
    @click="handleClick"
  >
    <div
      v-if="centered"
      class="tw-w-2 tw-min-w-2 tw-h-2"
    />
    <slot />
    <div>
      <svg-vue
        v-if="orderBy && name && orderDirection"
        icon="icons/chevron"
        class="tw-w-2 tw-min-w-2 tw-h-2 tw-transition-transform duration-500"
        :class="{
          'tw-rotate-180': orderBy === name && orderDirection === 'asc',
          'tw-opacity-0 group-hover:tw-opacity-100 group-hover:tw-text-blue group-hover:tw-animate-pulse': orderBy !== name,
        }"
      />
    </div>
  </div>
</template>
